<template>
  <Checkout />
</template>

<script>
import Checkout from '@/components/order/Checkout'
import { mapState } from 'vuex'

export default {
  name: 'CheckoutPage',
  components: { Checkout },
  computed: {
    ...mapState(['headline']),
  },
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: this.headline,
      }),
      meta: [
        {
          name: 'robots',
          content: 'noindex, follow',
        },
        {
          name: 'description',
          content: this.$t('meta.other.descriptionTmpl', {
            h1: this.headline,
          }),
        },
      ],
    }
  },
}
</script>
